import { Dialog } from "primereact/dialog"
import { Formik, Form } from "formik"
import RefTextAreaInput from "./RefTextAreaInput"
import refStyles from "../../styles/Referrals.module.css"
import { Button } from "primereact/button"
const ReferralNoteModal = ({
  createNewNote,
  setCreateNewNote,
  participantId,
  referralId,
  referralEntityId,
  referralOrganization,
  notePayload,
  referralCreatorUserId,
  handleSubmit,
}) => {
  return (
    <Dialog
      header={"New Referral note"}
      visible={createNewNote}
      style={{ width: "35vw" }}
      showHeader={false}
    >
      <Formik
        initialValues={{
          userId: participantId,
          note: "",
          referralId: referralId,
          referralEntityId: referralEntityId,
          notePayload: notePayload,
          referralCreatorUserId,
          participantId,
          organizationID: referralOrganization,
        }}
        enableReinitialize
        onSubmit={(values) => {
          handleSubmit(values)
        }}
      >
        {({ handleSubmit, isValid, isSubmitting, dirty, values, errors }) => (
          <Form onSubmit={handleSubmit}>
            <div className={refStyles.modalHeader}>
              <label>New Referral note</label>
              <Button
                icon="pi pi-times"
                type="button"
                className={refStyles.hideModalButton}
                onClick={() => {
                  setCreateNewNote(false)
                }}
                disabled={isSubmitting}
              />
            </div>
            <div className={refStyles.modalFormContainer}>
              <hr className={refStyles.modalHeaderLine} />
              <div className={refStyles.modalField} style={{ height: "200px" }}>
                <RefTextAreaInput
                  name="note"
                  placeholderText="Note"
                  style={{ bottom: "0" }}
                />
              </div>
              <div className={refStyles.footerNoBg}>
                <div
                  className={refStyles.modalFooter}
                  style={{ marginTop: "15px" }}
                >
                  <Button
                    label="Cancel"
                    type="button"
                    className={refStyles.cancelButton}
                    onClick={() => {
                      setCreateNewNote(false)
                    }}
                    disabled={isSubmitting}
                  />
                  <Button
                    label="Save"
                    type="submit"
                    icon={isSubmitting && "pi pi-spin pi-spinner"}
                    disabled={!dirty || isSubmitting}
                    className={`${refStyles.submitButton} ${
                      (!dirty || isSubmitting) && refStyles.submitDisabled
                    }`}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
export default ReferralNoteModal
